const config = {
  BASE_API_URL: process.env.REACT_APP_BASE_API_URL,
  GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  PET_TYPES: ["cat", "dog", "pet"],
  CLOUDINARY_UPLOAD_URL: process.env.REACT_APP_CLOUDINARY_UPLOAD_URL,
  CLOUDINARY_UPLOAD_PRESET: process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET,
};

export default config;
